import { z } from 'zod/v3';

const PathsSchema = z.object({
  auth: z.object({
    signIn: z.string().min(1),
    signUp: z.string().min(1),
    verifyMfa: z.string().min(1),
    callback: z.string().min(1),
    passwordReset: z.string().min(1),
    passwordUpdate: z.string().min(1),
  }),
  app: z.object({
    home: z.string().min(1),
    chat: z.string().min(1),
    personalAccountMemories: z.string().min(1),
    personalAccountAISettings: z.string().min(1),
    personalAccountAssistants: z.string().min(1),
    personalAccountKnowledgeBase: z.string().min(1),
    personalAccountWidgets: z.string().min(1),
    personalAccountRealtimeTranslate: z.string().min(1),
    personalAccountSettings: z.string().min(1),
    personalAccountBilling: z.string().min(1),
    personalAccountBillingReturn: z.string().min(1),
    accountHome: z.string().min(1),
    accountSettings: z.string().min(1),
    accountBilling: z.string().min(1),
    accountMembers: z.string().min(1),
    accountTeams: z.string().min(1),
    accountAudit: z.string().min(1),
    accountAnalytics: z.string().min(1),
    accountAssistants: z.string().min(1),
    accountKnowledgeBase: z.string().min(1),
    accountWidgets: z.string().min(1),
    accountBillingReturn: z.string().min(1),
    joinTeam: z.string().min(1),
    documents: z.string().min(1),
    createOrganization: z.string().min(1),
  }),
});

const pathsConfig = PathsSchema.parse({
  auth: {
    signIn: '/auth/sign-in',
    signUp: '/auth/sign-up',
    verifyMfa: '/auth/verify',
    callback: '/auth/callback',
    passwordReset: '/auth/password-reset',
    passwordUpdate: '/update-password',
  },
  app: {
    home: '/home',
    chat: '/chat',
    documents: '/home/documents',
    personalAccountMemories: '/home/settings/memories',
    personalAccountAISettings: '/home/settings/ai',
    personalAccountAssistants: '/home/settings/assistants',
    personalAccountKnowledgeBase: '/home/settings/knowledgebase',
    personalAccountWidgets: '/home/settings/widgets',
    personalAccountRealtimeTranslate: '/home/realtime-translate',
    personalAccountSettings: '/home/settings/profile',
    personalAccountBilling: '/home/billing',
    personalAccountBillingReturn: '/home/billing/return',
    accountHome: '/home/[account]',
    accountSettings: `/home/[account]/settings`,
    accountBilling: `/home/[account]/billing`,
    accountMembers: `/home/[account]/members`,
    accountTeams: `/home/[account]/teams`,
    accountAudit: `/home/[account]/audit`,
    accountAnalytics: `/home/[account]/analytics`,
    accountAssistants: `/home/[account]/assistants`,
    accountKnowledgeBase: `/home/[account]/knowledgebase`,
    accountWidgets: `/home/[account]/widgets`,
    accountBillingReturn: `/home/[account]/billing/return`,
    joinTeam: '/join',
    createOrganization: '/home/onboarding',
  },
} satisfies z.infer<typeof PathsSchema>);

export default pathsConfig;

// when adding a new path you probably want to add it to the routes as well apps/web/config/personal-account-navigation.config.tsx
